export type RequestStatus =
  | 'new'
  | 'registered'
  | 'code_sent'
  | 'awaiting_activation'
  | 'activation_validated'
  | 'processing'
  | 'processed'
  | 'cancelled'
  | 'expired';

export type CodeStatus = 'sent' | 'used' | 'invalidated' | 'expired';

export type LogLevel = 'info' | 'warning' | 'danger';

export const REQUEST_STATUSES: RequestStatus[] = [
  'new',
  'registered',
  'code_sent',
  'awaiting_activation',
  'activation_validated',
  'processing',
  'processed',
  'cancelled',
  'expired',
];

export const CODE_STATUSES: CodeStatus[] = ['sent', 'used', 'invalidated', 'expired'];

export const PROCESSING_ESTIMATE = '24 à 48 heures ouvrées';

/** Adresse de repli si aucun réglage administrateur n'est encore enregistré. */
export const ADMIN_EMAIL = 'liusbath67@gmail.com';
export const ADMIN_NAME = 'Administrateur PayLOTO';

/** Adresse de support affichée aux clients si aucun réglage n'est enregistré. */
export const SUPPORT_EMAIL = 'support@payloto.com';